import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Currency} from "../../interface/finance/currency";
import {environment} from "../../../../../environments/environment";
@Injectable({
  providedIn: 'root'
})
export class CurrencyService {

  private baseUrl = environment.apiBaseUrl;

  constructor(private http: HttpClient) { }
  get(id: number): Observable<any>{
    return this.http.get(`${this.baseUrl}/get/currency/${id}`);
  }
  getCollection(): Observable<Currency[]>{
    return this.http.get<Currency[]>(`${this.baseUrl}/get/currency`);
  }

  create(data: Currency): Observable<any>{
    return this.http.post<Currency>(`${this.baseUrl}/create/currency`, data);
  }

  edit(id: number, data: Currency): Observable<any>{
    return this.http.put<Currency>(`${this.baseUrl}/edit/currency/${id}`, data);
  }

  delete(id: number): Observable<Currency>{
    return this.http.delete<Currency>(`${this.baseUrl}/delete/currency/` + id);
  }
  deleteMultiple(ids: number[]): Observable<Currency[]>{
    const options = {body: ids};
    return this.http.delete<Currency[]>(`${this.baseUrl}/delete/currency`, options);
  }
}
